import { initialize } from 'launchdarkly-js-client-sdk';
import { env } from 'src/config/env';
import { resolveLaunchDarklyContextFromState } from 'src/store/feature-flags/launchDarkly.utils';

let ldClient = null;
let lastContextKey = null;

/**
 * @param {Function} getState
 * @returns {Promise<import('launchdarkly-js-client-sdk').LDClient|null>}
 */
export const syncLaunchDarklyClient = async (getState) => {
    const clientSideId = env.launchdarklyClientSideId;
    if (!clientSideId) {
        return null;
    }

    const context = resolveLaunchDarklyContextFromState(getState());
    const contextKey = JSON.stringify(context);

    if (!ldClient) {
        ldClient = initialize(clientSideId, context);
        await ldClient.waitForInitialization(10);
        lastContextKey = contextKey;
        return ldClient;
    }

    if (contextKey !== lastContextKey) {
        await ldClient.identify(context);
        lastContextKey = contextKey;
    }

    return ldClient;
};

/**
 * @param {Function} getState
 * @returns {Promise<Record<string, unknown>>}
 */
export const fetchAllLaunchDarklyFlags = async (getState) => {
    try {
        const client = await syncLaunchDarklyClient(getState);
        if (!client) {
            return {};
        }

        return client.allFlags();
    } catch (error) {
        console.warn('LaunchDarkly flag fetch failed:', error);
        return {};
    }
};

/** @internal test helper */
export const resetLaunchDarklyClientForTests = () => {
    ldClient = null;
    lastContextKey = null;
};
